import axios from 'axios'
import { FRONT_API_ENDPOINT } from 'enums/front-api-endpoint'

export const actions = {
  async sendLeadData(_, { payload }) {
    return await axios.post(FRONT_API_ENDPOINT.SUBMIT_LEAD(), payload)
  }
}
